import React from 'react';
import type { FieldValues } from 'react-hook-form';
import type { RadioGroupProps } from './RadioGroup';
import { RadioGroup } from './RadioGroup';
import { Label } from '../Label/Label';

export interface RadioGroupWithLabelProps<T extends FieldValues = FieldValues>
  extends Omit<RadioGroupProps<T>, 'children'> {
  labelText: string;
  labelClassName?: string;
  children: React.ReactNode;
}
// A RadioGroup with a label
export const RadioGroupWithLabel = <T extends FieldValues = FieldValues>({
  children,
  labelText,
  labelClassName,
  ...radioGroupProps
}: RadioGroupWithLabelProps<T>): React.ReactElement => (
  <RadioGroup<T> {...radioGroupProps}>
    <Label className={labelClassName}>{labelText}</Label>
    {children}
  </RadioGroup>
);
